// PATH: src/theme.js
// VERSION: 1.4 — Paleta + scroll en body (arreglo móvil)

import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  config: {
    initialColorMode: 'system',
    useSystemColorMode: true,
  },
  fonts: {
    heading: `'Outfit', sans-serif`,
    body: `'Inter', sans-serif`,
  },
  semanticTokens: {
    colors: {
      'bg.default': { default: 'brand.50', _dark: 'gray.900' },
      'bg.card': { default: 'white', _dark: 'gray.800' },
      'text.default': { default: 'gray.800', _dark: 'whiteAlpha.900' },
      'text.muted': { default: 'gray.600', _dark: 'gray.400' },
      'border.default': { default: 'gray.200', _dark: 'gray.700' },
    },
  },
  colors: {
    brand: {
      50: '#f8fafc',
      100: '#f1f5f9',
      200: '#e2e8f0',
      300: '#cbd5e1',
      400: '#94a3b8',
      500: '#64748b',
      600: '#475569',
      700: '#334155',
      800: '#1f2937',
      900: '#0f172a',
    },
    accent: {
      500: '#0ea5e9',
      600: '#0284c7',
    },
  },
  styles: {
    global: {
      'html, body, #root': { height: '100%' },
      html: {
        scrollbarGutter: 'stable',
      },
      body: {
        margin: 0,
        padding: 0,
        boxSizing: 'border-box',
        bg: 'bg.default',     // USANDO TOKEN SEMÁNTICO
        color: 'text.default', // USANDO TOKEN SEMÁNTICO
        overflowX: 'hidden',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
      },
      a: { color: 'accent.500' },
    },
  },
  components: {
    Button: {
      baseStyle: { borderRadius: 'lg' },
    },
    Heading: {
      baseStyle: { color: 'text.default' },
    },
    Text: {
      baseStyle: { color: 'text.default' },
    },
    Tag: {
      baseStyle: {
        borderRadius: 'full',
        fontWeight: 'semibold',
      },
    },
  },
});

export default theme;
